import { Theme, css } from '@emotion/react';

export const mobileHeading = ({ spacing }: Theme) => css`
  margin: 0 -${spacing(2)}px;
  padding-left: ${spacing(2)}px;
`;

export const cardsContainer = ({ breakpoints, spacing }: Theme) => css`
  margin: ${spacing(3)}px 0;

  ${breakpoints.up('sm')} {
    margin: ${spacing(3)}px;
  }
`;

export const formContainer = ({ breakpoints, spacing }: Theme) => css`
  margin: 0 ${spacing(2)}px;

  ${breakpoints.up('sm')} {
    margin: 0 ${spacing(3)}px;
  }
`;

export const formContainerElement = ({ breakpoints, spacing }: Theme) => css`
  ${breakpoints.up('sm')} {
    margin: 0 ${spacing(3)}px;
  }
`;

export const submitButton = ({ breakpoints, spacing }: Theme) => css`
  margin: ${spacing(2)}px 0;
`;
